module.exports = __webpack_public_path__ + "static/media/ic_load.f2e6e155.gif";